// Small shared helpers for the Data Toolkit UI.

// makeApi resolves to the axios response on success and the axios error on
// failure; pull (status, data) out of either shape.
export const unwrap = res => ({
  status: res?.status ?? res?.response?.status,
  data: res?.data ?? res?.response?.data
});

export const isTerminal = status =>
  status === "PROCESSED" || status === "FAILED";

export const statusMeta = status => {
  switch (status) {
    case "PROCESSED":
      return { label: "Completed", cls: "valid" };
    case "FAILED":
      return { label: "Failed", cls: "failed" };
    case "IN_PROGRESS":
      return { label: "Processing", cls: "running" };
    default:
      return { label: "Queued", cls: "running" };
  }
};

export const formatDate = ts => {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
};
